import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LocaleService } from '@app/system/services/locale.service';

declare var MediaRecorder: any;

@Component({
	selector: 'app-video-recorder',
	templateUrl: './video-recorder.component.html',
	styleUrls: ['./video-recorder.component.scss']
})
export class VideoRecorderComponent implements OnInit {
	mediaRecorder: any;
	chunks = [];
	audioFiles = [];
	@ViewChild('cameraPlaceholder', { static: true })
	cameraPlaceholder: ElementRef;
	// cameraPlaceholder: HTMLVideoElement;

	constructor(
		private cd: ChangeDetectorRef,
		public locale: LocaleService,
		private dom: DomSanitizer
	) { }

	ngOnInit(): void {
	}

	initialize() {
		if (typeof MediaRecorder === 'undefined' || !navigator.mediaDevices.getUserMedia) {
			alert(this.locale.translate('video_recorder_error'));
		} else {
			let constraints = { audio: true, video: true };
			navigator.mediaDevices.getUserMedia(
				constraints,
				// (stream) => {
				// 	this.startRecording(stream);
				// },
				// () => {
				// 	this.errorCallback();
				// }
			).then(
				(stream) => {
					this.startRecording(stream);
				},
				() => {
					this.errorCallback();
				}
			);
		}
		// if (navigator) {
		// 	navigator.getUserMedia(
		// 		{ audio: true, video: true },
		// 		(stream) => {
		// 			console.log(stream);
		// 			this.mediaRecorder = new MediaRecorder(stream);
		// 			this.mediaRecorder.onstop = (e) => {
		// 				console.log('data available after MediaRecorder.stop() called.');

		// 				// var clipName = prompt('Enter a name for your sound clip');

		// 				// var clipContainer = document.createElement('article');
		// 				// var clipLabel = document.createElement('p');
		// 				// var audio = document.createElement('audio');
		// 				// var deleteButton = document.createElement('button');

		// 				// clipContainer.classList.add('clip');
		// 				// audio.setAttribute('controls', '');
		// 				// deleteButton.innerHTML = 'Delete';
		// 				// clipLabel.innerHTML = clipName;

		// 				// clipContainer.appendChild(audio);
		// 				// clipContainer.appendChild(clipLabel);
		// 				// clipContainer.appendChild(deleteButton);
		// 				// soundClips.appendChild(clipContainer);

		// 				// audio.controls = true;
		// 				var blob = new Blob(this.chunks, { type: 'audio/ogg; codecs=opus' });
		// 				this.chunks = [];
		// 				var audioURL = URL.createObjectURL(blob);
		// 				// audio.src = audioURL;
		// 				this.audioFiles.push(this.dom.bypassSecurityTrustUrl(audioURL));
		// 				console.log(audioURL);
		// 				console.log('recorder stopped');
		// 				this.cd.detectChanges();
		// 			};
		// 			this.mediaRecorder.ondataavailable = (e) => {
		// 				this.chunks.push(e.data);
		// 			};
		// 		},
		// 		() => {
		// 			//alert('Error capturing audio.');
		// 		}
		// 	);
		// }
	}

	startRecording(stream) {
		this.mediaRecorder = new MediaRecorder(stream);
		this.mediaRecorder.start();
		let url = window.URL || window.webkitURL;
		this.cameraPlaceholder.nativeElement.srcObject = stream;
		this.cameraPlaceholder.nativeElement.play();
	}
	stopRecording() {
		this.mediaRecorder.stop();
	}
	errorCallback() { }
}
